<div
  [innerHTML]="sanitizedSvgContent$ | async"
  [style.width]="transformSize(width)"
  [style.height]="transformSize(height)"
  [attr.test-id]="testId"
  class="tw-m-0"
></div>
